import React from 'react';
import classNames from 'classnames';
import { formatCoursePrice } from '../../../../utilities';
import { giftCardIcon } from '../../../../assets';
import { t } from '../../../../../i18n';
import './styles.scss';

const GiftCardPreviewMobile = ({ className, price }) => {
  if (!price) {
    return (
      <div
        className={classNames(
          'courses-gift-card-preview-mobile',
          'courses-gift-card-preview-mobile__placeholder',
          'placeholder-glow',
        )}
      >
        <div className="placeholder" />
      </div>
    );
  }

  return (
    <section className={classNames('courses-gift-card-preview-mobile', className)}>
      <div className="courses-gift-card-preview-mobile__card">
        <img className="courses-gift-card-preview-mobile__gift-card" src={giftCardIcon} alt="Gift card" />
        <h2 className="courses-gift-card-preview-mobile__title">
          {t('DIGITAL_COURSES.GIFT_CARD_CHECKOUT.GIFT_CARD_WITH_PRICE', { price: formatCoursePrice(price) })}
        </h2>
        <div className="courses-gift-card-preview-mobile__text-info">
          <p className="courses-gift-card-preview-mobile__description">
            {t('DIGITAL_COURSES.GIFT_CARD_CHECKOUT.GIFT_CARD_INSTRUCTIONS')}
          </p>
          <p className="courses-gift-card-preview-mobile__remark">{t('DIGITAL_COURSES.GIFT_CARD_CHECKOUT.REMARK')}</p>
        </div>
      </div>
    </section>
  );
};

export default GiftCardPreviewMobile;
